import * as types from '../mutations'
import SCMFieldService from '@/services/SCMFieldService'

const state = {
  scmFields: [],
  count: 0,
  loading: true
}

const getters = {
  scmFields: (state) => state.scmFields,
  count: (state) => state.count,
  loading: (state) => state.loading
}

const actions = {
  async loadSCMFieldList ({ commit, rootGetters }) {
    commit(types.SCM_FIELD_LOADING)
    let data = await SCMFieldService.loadSCMFields(rootGetters['codes/usedCampaigns'])
    commit(types.SET_SCM_FIELD_LIST, data)
    commit(types.SCM_FIELD_LOADED)
  }
}

const mutations = {
  [types.SET_SCM_FIELD_LIST] (state, data) {
    state.scmFields = data
  },

  [types.SCM_FIELD_LOADING] (state) {
    state.loading = true
  },

  [types.SCM_FIELD_LOADED] (state) {
    state.loading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
